<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Autentificare</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="email"
                prepend-icon="mdi-email"
                name="email"
                label="email"
                type="email"
                :rules="[val => !!val || 'Camp obligatoriu!']"
                @keyup.enter="_cbLogin">
              </v-text-field>
              <v-text-field
                v-model="password"
                prepend-icon="mdi-lock"
                name="password"
                label="parola"
                :append-icon="pwdVis ? 'mdi-eye' : 'mdi-eye-off'"
                :type="pwdVis ? 'text' : 'password'"
                :rules="[val => !!val || 'Camp obligatoriu!']"
                @click:append="_cbTogglePwdVis"
                @keyup.enter="_cbLogin">
              </v-text-field>
            </v-form>
            <v-alert
              v-model="alert"
              dismissible
              type="error">
              {{error}}
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="_cbLogin" :disabled="loading" :loading="loading">
              Intra in aplicatie
              <template v-if="clicks">
                ({{ clicks }})
              </template>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  data: () => ({
    pwdVis: false,
    email: null,
    password: null,
    error: null,
    alert: false,
    loading: false,
    clicks: 0
  }),
  methods: {
    _cbTogglePwdVis () {
      this.pwdVis = !this.pwdVis
    },
    _cbLogin () {
      this.clicks++
      if (!this.loading && this.email && this.password) {
        this.login()
      }
    },
    login: debounce(function () {
      // console.log('click')
      this.loading = true
      this.$store.dispatch('login', { email: this.email, password: this.password })
        .then(res => {
          this.$router.push({ name: 'index' })
          this.loading = false
          this.clicks = 0
        })
        .catch(err => {
          console.log(err)
          this.alert = true
          this.error = 'Autentificare esuata...'
          this.loading = false
          this.clicks = 0
        })
    }, 500)
  }
}
</script>

<style>

</style>
